import classNames from 'classnames';
import React, { memo } from 'react';

import { useAnalytics } from '@features/Analytics';

import styles from '../links.module.scss';

export const RefundLink = memo(
  ({
    place,
    className,
    children,
  }: {
    place: 'paywall' | 'checkout' | 'burger_menu' | 'email_modal' | 'upsale';
    className?: string;
    children?: React.ReactNode;
  }) => {
    const { trackGoogleEvent } = useAnalytics();
    return (
      <a
        className={classNames(styles.link, className)}
        href="https://legal.mentalgrowth.app/eclipse/refund-policy.pdf"
        target="_blank"
        rel="noreferrer"
        onClick={() =>
          trackGoogleEvent({
            eventName: 'link_open',
            options: { place: place, link_name: 'refund policy' },
          })
        }>
        {children || <>Refund Policy</>}
      </a>
    );
  },
);

RefundLink.displayName = 'RefundLink';
